import React from 'react'

import { observer } from 'mobx-react-lite'

import { FaIcon } from '#components/FaIcon'
import { Toolbar } from '#components/Toolbar'
import { ButtonMode, ILoadedScript } from '#state/types'

interface Props {
  script?: ILoadedScript
  toggleSnapshotsPanel: () => void
  mode?: ButtonMode
}

export const OpenSnapshotSidebar = observer<Props>((props) => {
  return (
    <Toolbar.Button
      customIcon={<FaIcon icon="fa-clock-rotate-left" />}
      label="History"
      mode={props.mode}
      onClick={props.toggleSnapshotsPanel}
    />
  )
})
